var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[(_vm.type === 'jetton_wallet' || _vm.skeletonHint === 'jetton_wallet')?_c('jetton-wallet',_vm._b({attrs:{"address":_vm.address,"wallet":_vm.wallet}},'jetton-wallet',_vm.props,false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }